// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__gzOjC","left":"StickyBox_left__1VF8U","right":"StickyBox_right__3Ayfn"};